import {Button, Icon} from '@hm/fundamental'
import {mdiRefresh} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../localization'

export const AnalysisRefreshToast = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  return (
    <div className="flex flex-col gap-2">
      <p className="text-base font-medium">{t('label.analysisRefresh')}</p>
      <Button
        variant="secondary"
        onClick={() => {
          window.location.reload()
        }}
        iconPrefix={<Icon path={mdiRefresh} size="large" />}
      >
        {t('buttons.refresh')}
      </Button>
    </div>
  )
}
